// Minimal Markdown renderer for consent documents.
// Supports: "## Heading", "- bullet", "**bold**" inline, blank-line paragraphs.

function renderInline(text, keyPrefix) {
    const parts = text.split(/(\*\*[^*]+\*\*)/g);
    return parts.map((p, i) => {
        if (p.startsWith("**") && p.endsWith("**")) {
            return <strong key={`${keyPrefix}-${i}`} className="text-phoenix-navy font-semibold">{p.slice(2, -2)}</strong>;
        }
        return <span key={`${keyPrefix}-${i}`}>{p}</span>;
    });
}

export function MarkdownView({ body, className = "" }) {
    if (!body) return null;
    const lines = body.replace(/\r\n/g, "\n").split("\n");
    const blocks = [];
    let list = null;
    const flushList = () => { if (list) { blocks.push({ type: "ul", items: list }); list = null; } };

    lines.forEach((raw) => {
        const line = raw.trimEnd();
        if (line.startsWith("## ")) {
            flushList();
            blocks.push({ type: "h2", text: line.slice(3).trim() });
        } else if (line.trimStart().startsWith("- ")) {
            if (!list) list = [];
            list.push(line.trimStart().slice(2));
        } else if (line.trim() === "") {
            flushList();
        } else {
            flushList();
            blocks.push({ type: "p", text: line });
        }
    });
    flushList();

    return (
        <div className={`space-y-3 text-sm text-muted-foreground leading-relaxed ${className}`}>
            {blocks.map((b, i) => {
                if (b.type === "h2") {
                    return <h2 key={i} className="font-display text-lg font-semibold text-phoenix-navy mb-2 mt-6 border-b border-border/60 pb-2">{b.text}</h2>;
                }
                if (b.type === "ul") {
                    return (
                        <ul key={i} className="list-disc pl-5 space-y-1">
                            {b.items.map((it, j) => <li key={j}>{renderInline(it, `${i}-${j}`)}</li>)}
                        </ul>
                    );
                }
                return <p key={i}>{renderInline(b.text, `p-${i}`)}</p>;
            })}
        </div>
    );
}
